import { MobileTooltip } from "./mobile-tooltip";
import { Tooltip } from "./tooltip";
import type { TooltipProps } from "./types";

export const HybridTooltip = ({ children, ...props }: TooltipProps) => {
  const isMobileApp = false; // checkIsMobileApp();
  const Wrapper = isMobileApp ? MobileTooltip : Tooltip;

  return <Wrapper {...props}>{children}</Wrapper>;
};
